export const mugImprintID =  "823b9251-4c07-4351-b177-60190d7675f9";
// NOTE: why buy ID is also stored in locale key: infopages > employment
export const whyBuyID = "3e8cba4a-f0f5-4d34-819e-c221131719bf";
export const beCertainID = "a1488d91-3d14-4ce8-9543-8439211b2a72";